class WebStorage {
	#storage: Storage

	constructor(storage: Storage) {
		this.#storage = storage
	}

	get(key: string): string | null {
		try {
			return this.#storage.getItem(key)
		} catch {
			return null
		}
	}

	set(key: string, value: string) {
		try {
			this.#storage.setItem(key, value)
		} catch {
			// Silently ignore
		}
	}

	remove(key: string) {
		try {
			this.#storage.removeItem(key)
		} catch {
			// Silently ignore
		}
	}

	clear() {
		try {
			this.#storage.clear()
		} catch {
			// Silently ignore
		}
	}
}

export const storage = new WebStorage(window.localStorage)
